import { signalStoreFeature, withMethods } from '@ngrx/signals';
import { EntityId, withEntities } from '@ngrx/signals/entities';

export function withUtils<T extends { id: EntityId }>() {
  return signalStoreFeature(
    withEntities<T>(),
    withMethods((store) => {
      function getEntityById(id: string): T | null {
        return store.entities().find((entity) => entity.id === id) || null;
      }
      function getElementById(arrayToSearch: T[], id: string): T | null {
        return arrayToSearch.find((entity) => entity.id === id) || null;
      }
      return {
        getEntityById,
        getElementById,
      };
    }),
  );
}
